import { array, boolean, number, object, string, } from 'yup';
export const genericBookingFormSpec = {
    VisitDate: string().required('Please select a date').nullable(),
    acceptTerms: boolean(),
};
// .oneOf([true], 'Please accept the terms and conditions'),
export const signatureNeededSchema = {
    signature: string().required('Please add a signature'),
    SignatureDate: string().required(),
};
export const genericBookingFormVisitors = {
    Visitors0: number().nullable().notRequired(),
    Visitors1: number().nullable().notRequired(),
    Visitors2: number().nullable().notRequired(),
    Visitors3: number().nullable().notRequired(),
    Visitors4: number().nullable().notRequired(),
    Visitors5: number().nullable().notRequired(),
    Visitors6: number().nullable().notRequired(),
    Visitors7: number().nullable().notRequired(),
    Visitors8: number().nullable().notRequired(),
};
export const genericValidation = {
    ...genericBookingFormSpec,
    ...genericBookingFormVisitors,
};
export const genericSingleActivity = {
    ProductId: number().default(277),
    session: number().required('Please select a valid session'),
    ...genericValidation,
};
export const genericMultiActivitySession = {
    ActivityId: number().required('Please select a valid session'),
    SessionId: number().nullable().notRequired(),
    Visitors0: number().nullable().notRequired(),
    Visitors1: number().nullable().notRequired(),
    Visitors2: number().nullable().notRequired(),
    Visitors3: number().nullable().notRequired(),
    Visitors4: number().nullable().notRequired(),
    Visitors5: number().nullable().notRequired(),
    Visitors6: number().nullable().notRequired(),
    Visitors7: number().nullable().notRequired(),
    Visitors8: number().nullable().notRequired(),
};
// DIY Date picker
export const genericMultiActivity = {
    ...genericBookingFormSpec,
    DayTicketId: number().default(4),
    Sessions: array(object(genericMultiActivitySession)).required('Please select timeslots for all activities'),
};
export const genericDayTicket = {
    DayTicketId: number().default(277),
    Sessions: array(object({
        ActivityId: number(),
        SessionId: number().required('Please select a valid session'),
    })).required('Please select timeslots for all activities'),
    ...genericValidation,
};
export const genericSchema = object(genericValidation);
export const singleActivitySchema = object(genericSingleActivity);
export const multiActivitySchema = object(genericMultiActivity);
export const multiActivitySessionSchema = object(genericMultiActivitySession);
export const dayTicketSchema = object(genericDayTicket);
export default genericBookingFormSpec;
